import {
	Box,
	Button,
	Grid,
	IconButton,
	Link,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FrequentFip from './FrequentFip';
import { useContext, useEffect, useState } from 'react';
import SearchFip from './SearchFip';
import Footer from '../Sections/Footer';
import linkedAccountsSectionStyles from '../Accounts/LinkedAccountsSection.styles';
import { topFipList as topFips } from '../../assets/topFipList';
import addAccountStyles from './AddAccount.styles';
import ConsentListContext from '../Context/ConsentContext';
import AuthApis from '../../hepler/authApis.service';
import abbreviationMap from '../../utils/abbreviationMap';
import StepperContext from '../Context/StepperContext';
import { UserActionContext } from '../Context/UserActionContext';
import { useTranslation } from '../../hooks/useTranslation';

function AddAccount(props) {
	const { t } = useTranslation();
	const { userSelectedFiType, updateUserSelectedFiType } =
		useContext(UserActionContext);
	const { nextStep } = useContext(StepperContext);
	const { enabledFipList, isNewUser } = props;
	const consentsContext = useContext(ConsentListContext);
	const consentsAll = consentsContext.consentList;
	const fiTypesAllConsents = [];
	const authApis = new AuthApis();
	consentsAll.forEach((consent) => fiTypesAllConsents.push(...consent.fiTypes));

	// Clear targeted discovery mode when manually adding accounts
	useEffect(() => {
		if (global.redirectAccountRestrictions) {
			delete global.isTargetedDiscoveryMode;
		}
	}, []);

	const getPersistedFiTypes = () => {
		const currentFiTypes = props.history.location.state?.fiTypes;
		if (currentFiTypes) {
			updateUserSelectedFiType(currentFiTypes);
			return currentFiTypes;
		} else if (userSelectedFiType) {
			return userSelectedFiType;
		} else {
			updateUserSelectedFiType(fiTypesAllConsents);
			return fiTypesAllConsents;
		}
	};

	const fiSelected = getPersistedFiTypes();

	const enabledFipListFiltered = fiSelected
		? enabledFipList?.filter((x) =>
				x?.fipFitypes?.some((fi) => fiSelected?.includes(fi))
		  )
		: enabledFipList;

	const topFipList = enabledFipListFiltered
		?.filter((x) => topFips?.includes(x?.fipId))
		?.map((x) => x?.fipId);

	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));
	
	// Check for dark theme
	const isDark = props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';
	
	const [topFip, setTopFip] = useState(topFipList);

	const otherFip = enabledFipListFiltered.filter(
		(x) => !topFip.includes(x.fipId)
	);
	const [searchResults, setSearchResults] = useState(otherFip);
	const [selectedFipList, setSelectedFipList] = useState([]);

	const handleSearch = (value) => {
		let searchValue = value.toUpperCase();
		let results = otherFip.filter((Fip) => {
			let productName = Fip?.productName.toUpperCase();

			// Check if product name contains the search term
			if (productName.includes(searchValue)) {
				return true; // If directMatch is true, return immediately no abbrevation matching required.
			}

			// Check for abbreviation matches
			return Object.keys(abbreviationMap).some((abbr) => {
				const abbrMatch = abbr.toUpperCase().includes(searchValue);
				const fullNameMatch = productName.includes(
					abbreviationMap[abbr].toUpperCase()
				);
				return abbrMatch && fullNameMatch;
			});
		});

		setSearchResults(results);
	};

	let institution = 'institution';
	switch (fiSelected) {
		case 'DEPOSIT':
		case 'TERM-DEPOSIT':
		case 'RECURRING_DEPOSIT':
			institution = 'Banks';
			break;
		case 'INSURANCE_POLICIES':
			institution = 'Insurance Companies';
			break;
		case 'MUTUAL_FUNDS':
		case 'EQUITIES':
			institution = 'Mutual Fund Companies';
			break;
		case 'GSTR1_3B':
			break;
		default:
			break;
	}

	const handleCheckboxChange = (event, fipId) => {
		const isChecked = event.target.checked;
		if (global?.allowMultipleFipDiscovery !== 'true') {
			return props.goToAccounts(fipId);
		}
		if (isChecked) {
			setSelectedFipList((prevSelected) => [...prevSelected, fipId]);
		} else {
			setSelectedFipList((prevSelected) =>
				prevSelected.filter((id) => id !== fipId)
			);
			setTopFip((prevSelected) =>
				prevSelected.filter((id) =>
					!topFipList.includes(id) ? id !== fipId : true
				)
			);
			setSearchResults((prevSearchResults) => [
				...prevSearchResults,
				...enabledFipListFiltered.filter(
					(fip) => fip.fipId === fipId && !topFipList.includes(fip.fipId)
				),
			]);
		}
	};

	const handleOtherFipCheckboxChange = (event, fip) => {
		authApis.clearStack();
		const isChecked = event.target.checked;
		handleCheckboxChange(event, fip.fipId);
		if (isChecked) {
			setTopFip((prevSelected) => [...prevSelected, fip.fipId]);
			setSearchResults((prevSearchResults) =>
				prevSearchResults.filter((fipSearch) => fipSearch.fipId !== fip.fipId)
			);
		} else {
			setTopFip((prevSelected) =>
				prevSelected.filter((id) => id !== fip.fipId)
			);
		}
	};
	return (
		<>
			<Box
				sx={{
					minWidth: mobileScreen ? '100vw' : 'auto',
					padding: mobileScreen
						? '2rem 1.5rem 5.5rem 1.5rem'
						: '2rem 1.875rem 6rem 1.875rem',
					backgroundColor: isDark ? '#161616' : theme.palette.primary.light,
					color: isDark ? '#FFFFFF' : '#000000',
					gap: mobileScreen ? '1.25rem' : '1.5rem',
					...addAccountStyles.container,
				}}
			>
				<Box width={'100%'}>
					<Box sx={addAccountStyles.flexRowSb}>
						<Box sx={addAccountStyles.flexRowC}>
							{!mobileScreen && global.isAddAccount ? (
								<IconButton
									disableRipple
									sx={{ pl: 0 }}
									onClick={() => {
										props.history.push('/payment-consent');
										nextStep(1);
									}}
								>
									<ArrowBackIcon sx={{ color: theme.palette.primary.main }} />
								</IconButton>
							) : mobileScreen &&
							  global?.allowMultipleFipDiscovery !== 'true' ? (
								<IconButton
									disableRipple
									sx={{ pl: 0 }}
									onClick={() => {
										props.history.push('/payment-consent');
										nextStep(1);
									}}
								>
									<ArrowBackIcon sx={{ color: theme.palette.primary.main }} />
								</IconButton>
							) : null}
							<Typography sx={{
						...addAccountStyles.title,
						color: isDark ? '#FFFFFF' : 'inherit'
					}}>
								{t('accountDiscovery.titles.addNewAccount')}
							</Typography>
						</Box>
						{!mobileScreen && global?.allowMultipleFipDiscovery === 'true' && (
							<Button
								size="large"
								variant="contained"
								onClick={() => {
									authApis.clearStack();
									props.goToAccounts(selectedFipList);
								}}
								disabled={selectedFipList.length === 0}
								sx={{
									textTransform: 'capitalize',
									width: '15%',
									backgroundColor:
										props?.customDetails?.ctaBackgroundColor ??
										props.customDetails.primaryColor,
									border: `1px solid ${
										props?.customDetails?.ctaBorderColor ??
										props?.customDetails?.primaryColor
									}`,
									'&:hover': {
										backgroundColor:
											props?.customDetails?.ctaHoverPrimaryColor ??
											props?.customDetails?.primaryColor,
										border: props?.customDetails?.ctaHoverBorderColor
											? `1px solid ${props?.customDetails?.ctaHoverBorderColor}`
											: `1px solid ${props?.customDetails?.primaryColor}`,
									},
									'&.Mui-disabled': {
										border: props?.customDetails?.ctaDisableBorderColor
											? `1px solid ${props?.customDetails?.ctaDisableBorderColor}`
											: '0', // or any style you want
									},
								}}
							>
								{t('common.buttons.next')}
							</Button>
						)}
					</Box>
					<Typography
						color={isDark ? '#7A8185' : theme.palette.black60}
						sx={addAccountStyles.subTitle}
					>
						{t('accountDiscovery.messages.selectInstitution')}&nbsp;
						<span
							style={{
								color: isDark ? '#FFFFFF' : theme.palette.info.main,
								fontWeight: '700',
							}}
						>
							{global.mobileNumber
								? global.mobileNumber
								: global.mobileNumberArray[0]}{' '}
							{'. '}{' '}
						</span>
						{global.sdkOptions?.allowDifferentMobile === 'Y' && (
							<Link
								color={theme.palette.primary.main}
								onClick={() => {
									props.history.push(
										`/NoAccountFound/${global.mobileNumber}?step=${101}&fip=${
											props.match.params.fid
										}`
									);
								}}
								sx={addAccountStyles.changeNumberLink}
							>
								{t('common.buttons.changeMobileNumber')}
								<br />
							</Link>
						)}
						{t('accountDiscovery.messages.infoSharing')}
					</Typography>
				</Box>
			<Grid
				container
					display={topFip.length > 0 ? 'flex' : 'none'}
					sx={addAccountStyles.topFipContainer}
				>
					{topFip.map((fipId) =>
						props.customDetails?.excludeFIP ? (
							!props.customDetails?.excludeFIP.includes(fipId) && (
								<FrequentFip
									key={fipId}
									selectedFipList={selectedFipList}
									handleCheckboxChange={handleCheckboxChange}
									{...props}
									fipId={fipId}
									popular={true}
								/>
							)
						) : (
							<FrequentFip
								key={fipId}
								selectedFipList={selectedFipList}
								handleCheckboxChange={handleCheckboxChange}
								{...props}
								fipId={fipId}
								popular={true}
							/>
						)
					)}
				</Grid>
				<SearchFip
					handleOtherFipCheckboxChange={handleOtherFipCheckboxChange}
					searchResults={searchResults}
					handleSearch={handleSearch}
					topFip={topFip}
					{...props}
				/>
			</Box>

			{mobileScreen ? (
				<Box
					sx={{
				bottom: mobileScreen ? '40px' : '3rem',
				right: mobileScreen ? '0rem' : '0rem',
				backgroundColor: mobileScreen ? (isDark ? '#161616' : (props.customDetails?.secondaryColor || '#ffffff')) : 'none',
			borderTop: mobileScreen ? '1px solid #E0E0E0' : 'none',
		borderBottom: mobileScreen ? '1px solid #E0E0E0' : 'none',
					color: mobileScreen ? (isDark ? '#FFFFFF' : '#000000') : 'inherit',
						gap: mobileScreen ? '1rem' : '1.25rem',
						width: mobileScreen ? '100vw' : '20%',
						flexWrap: 'wrap',
						...linkedAccountsSectionStyles.buttonGroup,
					}}
				>
					{global?.allowMultipleFipDiscovery === 'true' && (
						<>
							<Button
								variant="outlined"
								fullWidth={mobileScreen}
								color="primary"
								onClick={() => {
									props.history.push('/payment-consent');
									nextStep(1);
								}}
								sx={{ 
								flex: 1, 
								background: isDark ? 'transparent' : theme.palette.primary.white,
								color: isDark ? '#FFFFFF' : theme.palette.primary.main,
								borderColor: isDark ? '#FFFFFF' : theme.palette.primary.main,
								'&:hover': {
									background: isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(25, 118, 210, 0.04)',
									borderColor: isDark ? '#FFFFFF' : theme.palette.primary.main,
								}
							}}
							>
								{t('common.buttons.back')}
							</Button>
							<Button
								variant="contained"
								disabled={selectedFipList.length === 0}
								fullWidth={mobileScreen}
								onClick={() => {
									authApis.clearStack();
									props.goToAccounts(selectedFipList);
								}}
								sx={{
									backgroundColor: props.customDetails.primaryColor,
									flex: 1,
								}}
							>
					{t('common.buttons.next')}
						</Button>
					</>
				)}
		</Box>
	) : null}
	<Footer fixed={true} customDetails={props.customDetails} />
	</>
	);
}

export default AddAccount;
